const _ = require('lodash');
const computed = require('../computed/auth/registration');
const computedIndex = require('../computed/auth/index');
let { thenWithErrorHandling } = require('../../helpers/errorHandler');
let debouncedRegisterAuthUser = _.debounce(registerAuthUser, 1000);

function registerAuthUser (args, state, output, { locator, context }) {
    let formData = state.get(['registration', 'form']);

    let registerData = {
        grant_type: 'email',
        email: formData.email,
        password: formData.password
    };

    let queryData = {
        client_id: 'hermes',
        locale: 'ru_RU',
        template: '/static/mail/template/register.twig'
    };

    let API = locator.resolve('api');
    let request = API.registerAuthUser(context, { registerData, queryData });

    request.then((data) => {
        let code = _.get(data, 'status.code');

        if (code === 201) {
            output.success({ auth: _.get(data, 'content') });
            return;
        }

        const statusMap = {
            EntityExists: 'emailAlreadyUsed'
        };

        let error = _.get(data, 'content.error');

        let status = statusMap[error];

        output[status]({ data });
    })
        .catch((error) => output.error({ error }));
}

module.exports = {
    /**
     * Устанавливаем computed поля для страницы регистрации
     * @param {Object} args
     * @param {Object} state
     */
    setComputedFields (args, state) {
        computed.registerButton(state);
        computed.setRepeatPasswordError(state);
        computed.isUserTypeSelectEnabled(state);
        computedIndex.computeCountryDropdown(state, ['registration']);
    },

    getCountries (args, state, output, { locator, context }) {
        let API = locator.resolve('api');
        let request = API.getCountries(context, locator);

        thenWithErrorHandling(
            request,
            (data) => ({ countries: _.get(data, 'content') }),
            output);
    },

    fillLoginForm (args, state) {
        let loginForm = {
            password: state.get(['registration', 'form', 'password']),
            username: state.get(['registration', 'form', 'email'])
        };

        state.set(['login', 'form'], loginForm);
    },

    debouncedRegisterAuthUser,

    registerHermesUser ({ auth }, state, output, { locator, context }) {
        let formData = state.get(['registration', 'form']);
        let token = auth.access_token;

        let requiredFields = ['city', 'email', 'firstName', 'middleName', 'lastName', 'phone',
            'isAcceptPersonalDataProcessing', 'userType', 'countryId', 'legalAddress'];
        if (formData.userType === 2) {
            requiredFields = requiredFields.concat(['organization', 'kpp']);
        } else if (formData.userType === 3) {
            requiredFields = requiredFields.concat(['organization']);
        }
        let registerData = _.chain(formData)
            .pick(requiredFields)
            .omitBy(_.isUndefined)
            .value();

        if (formData.userType === 2) {
            switch (formData.countryId) {
                case 1:
                    registerData.inn = formData.inn10;
                    break;
                case 4:
                    registerData.inn = formData.bin;
                    break;
                default:
                    break;
            }
        } else if (formData.userType === 3) {
            switch (formData.countryId) {
                case 1:
                    registerData.inn = formData.inn12;
                    break;
                case 4:
                    registerData.inn = formData.bin;
                    break;
                default:
                    break;
            }
        }

        let API = locator.resolve('api');
        let request = API.registerHermesUser(context, locator, { registerData, token });

        request.then((data) => {
            let code = _.get(data, 'status.code');
            let status = _.get(data, 'content.status');

            if (code !== 200) {
                output[status]({ code });
                return;
            }

            output[status]({ data });
        })
        .catch((error) => output.error({ error }));
    },

    acceptPersonalDataProcessing (args, state) {
        state.set(['registration', 'form', 'isAcceptPersonalDataProcessing'], true);
    },

    declinePersonalDataProcessing (args, state) {
        state.set(['registration', 'form', 'isAcceptPersonalDataProcessing'], false);
    },

    setRegistrationProperty ({ path, value }, state) {
        state.set(['registration', 'form', path], value);
    }
};



// WEBPACK FOOTER //
// ./actions/auth/registration.js